import React from "react";
import { Button, Card, Col, Form, Input, Row, Select, Alert, Radio, Spin } from "antd";
const { Option } = Select;
import { ArrowRightOutlined } from '@ant-design/icons';
import api_url from '../../../utils/requestApi';
import ServerApi from '../../../utils/ServerApi';
import appConst from '../../../constents/app.const';

class WithdrawAction extends React.Component{
    constructor(props){
        super(props)
        this.get_method_list = this.get_method_list.bind()
    }
    formRef = React.createRef()
    state={
        authFail: false,
        authFailMsg: 'Input correct data',
        method: [],
        w_final_amount: 0.0,
        number: {},
        loading: false
    }
    componentDidMount(){
        this.get_method_list()
    }
    get_method_list = () => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.work_data(api_url.with_method, returnData => {
            if(returnData.success == 1){
                this.setState({method: returnData.method})
            }
        })
        serverApi.work_data(api_url.get_to_phone_list, returnData => {
            if(returnData.success == 1){
                this.setState({number: returnData.number})
            }
        })
    }
    amount_keyup = (e) => {
        let notify = document.querySelector('.rate-limit')
        notify.style.display = 'block'
        this.setState({w_final_amount: e.target.value})
    }
    onReset = () => {
        this.formRef.current.resetFields()
    }
    onFinish = (e) => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
            serverApi.account_actions(api_url.with_action, 'POST', e, returnData => {
                if(returnData.success == 1){
                    this.setState({
                        authFail: false,
                        authFailMsg: returnData.message,
                        loading: false
                    }, () => {
                        this.onReset();
                        this.props.onMyAccount();
                        let notify = document.querySelector('.rate-limit');
                        notify.style.display = 'none';
                    })
                }else{
                    this.setState({
                        authFail: true,
                        authFailMsg: returnData.message,
                        loading: false
                    })
                }
            })
        })
    }
    render(){
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        <Card>
                            <u className="ml-5"><h5>Withdraw Action</h5></u>
                            {this.state.authFail ? <Alert message={this.state.authFailMsg} type="error" showIcon /> : 
                            <Alert message={this.state.authFailMsg} type="success" showIcon />}
                            <Spin tip="processing..." spinning={this.state.loading}>
                                <Form
                                    ref={this.formRef}
                                    onFinish={this.onFinish}
                                >
                                    <div className="pb-10">
                                        <label>Method</label>
                                        <Form.Item
                                            name="method"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please select method',
                                            },
                                            ]}
                                        >
                                            <Radio.Group
                                                buttonStyle="solid"
                                            >
                                                {this.state.method.map((method, index) => {
                                                    return(
                                                        <Radio.Button
                                                            key={index}
                                                            dashed
                                                            value={method.no}
                                                            style={{margin: '2px', height: '40px'}}
                                                        >
                                                            <img src={"./img/method/"+method.title+".png"} width="40"/>
                                                            <span style={{marginLeft: '2px'}}>{method.title}</span>
                                                        </Radio.Button>
                                                    )
                                                })}
                                            </Radio.Group>
                                            {/* <Select
                                                style={{width: '100%'}}
                                            >
                                                {this.state.method.map((method, index) => {
                                                    return(
                                                        <Option key={index} value={method.no}>{method.title}</Option>
                                                    )
                                                })}
                                            </Select> */}
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10">
                                        <label>Type</label>
                                        <Form.Item
                                            name="account_type"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please select type',
                                            },
                                            ]}
                                        >
                                            <Select
                                                style={{width: '100%'}}
                                                options={[
                                                    {
                                                        value: 'Personal',
                                                        label: 'Personal'
                                                    },
                                                    {
                                                        value: 'Agent',
                                                        label: 'Agent'
                                                    }
                                                ]}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10">
                                        <label>To</label>
                                        <Form.Item
                                            name="to_number"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input your phone number',
                                            },
                                            ]}
                                        >
                                            {/* <Input type="number" placeholder="+8801123456789"/> */}
                                            {(this.state.number.phone_1 != 0 || this.state.number.phone_2 != 0 || this.state.number.phone_3 != 0)?<Select
                                                style={{width: '100%'}}
                                            >
                                                {this.state.number.phone_1 != 0?<Option key={1} value={this.state.number.phone_1}>{this.state.number.phone_1}</Option>:''}
                                                {this.state.number.phone_2 != 0?<Option key={2} value={this.state.number.phone_2}>{this.state.number.phone_2}</Option>:''}
                                                {this.state.number.phone_3 != 0?<Option key={3} value={this.state.number.phone_3}>{this.state.number.phone_3}</Option>:''}
                                            </Select>:<Input type="number" placeholder="+8801123456789"/>}
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10 rate-limit" style={{display: 'none'}}>
                                        <Row style={{textAlign: 'center', color: 'green'}}>
                                            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <label>Rate <br/> {this.state.w_final_amount} x 1.0</label>
                                            </Col>
                                            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <label><br/><ArrowRightOutlined /></label>
                                            </Col>
                                            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <label>Final Amount <br/> <b>{this.state.w_final_amount}</b></label>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <label style={{color: 'black'}}>Limit: <span>100</span> to <span>20000</span> </label>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="pb-10">
                                        <label>Amount</label>
                                        <Form.Item
                                            name="amount"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input valid amount',
                                            },
                                            ]}
                                        >
                                            <Input type="number" placeholder="amount" maxLength={5} onChange={this.amount_keyup}/>
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10">
                                        <label>6 Digit Pin</label>
                                        <Form.Item
                                            name="password"
                                            rules={[
                                            {
                                                required: true,
                                                message: 'Please input 6 digit pin',
                                            },
                                            ]}
                                        >
                                            <Input.Password type="password" placeholder="6 Digit Pin"/>
                                        </Form.Item>
                                    </div>
                                    <div className="pb-10">
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit" block>Submit</Button>
                                        </Form.Item>
                                    </div>
                                </Form>
                            </Spin>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default WithdrawAction;